import React from "react";

const Divider = () => {
    return(
        <hr className="border-0 bg-gray-400 h-px w-1/4 mt-12 mb-10" />
    );
}

export default Divider;